<template>
    <div v-if="menu">
        <div style="float: left" v-if="isEdit">
            <a href="javascript:void(0);" class="btn btn-danger btn-sm" style="margin-left: 10px;"  @click="$emit('onDelete')"><span class="glyphicon glyphicon-trash" ></span></a>
        </div>
        <div style="width: 70%;float: left;padding: 0px 16px; ">
            <a href="javascript:void(0)" @click="menu.isShow = true" v-if="isEdit">{{menu.title}} <span class="glyphicon glyphicon-pencil"></span> </a>
            <div v-else>{{menu.title}}</div>
        </div>
        <a href="javascript:void(0);" class="hidden-xs" style="position:absolute;right: 0;float:left;width: 22px;margin-top: 4px;display: inline-block" v-if="menu.type == 'nested'" @click="$emit('onSelectNested')"><span class="glyphicon glyphicon-menu-right"></span></a>
        <a href="javascript:void(0);" class="hidden-sm hidden-md hidden-lg" style="position:absolute;right: 0;float:left;width: 22px;margin-top: 4px;display: inline-block" v-if="menu.type == 'nested'" @click="$emit('onSelectNested')"><span class="glyphicon glyphicon-menu-down"></span></a>


        <div v-if="menu.isShow" style="z-index: 1000;background: white; position: absolute;border: 1px solid #c1c1c1;border-radius: 10px;top: -160px;left: 10px;text-align:left;min-width: 280px;">
            <div style="border-bottom: 1px solid #eee;padding: 10px" :class="{'has-error': errors.has('buttonName')}">
                <p class="small">Button Name</p>
                <input type="text" data-vv-as="Button Name" :data-vv-name="'buttonName'" name="buttonName" id="buttonName" class="form-control" placeholder="Button Name" v-model="menu.title" style="width: 100%" v-validate="'required'" @keyup="onChange">
                <p class="text-error" v-show="errors.has('buttonName')">{{ errors.first('buttonName') }}</p>
            </div>

            <div style="padding: 10px;">
                <ul class="nav nav-tabs">
                    <li role="presentation" :class="{'active' : menu.type == 'postback'}"><a href="javascript:void(0);" @click="changeMenuType('postback')"><span class="glyphicon glyphicon-font"></span> Text</a></li>
                    <li role="presentation" :class="{'active' : menu.type == 'web_url'}"><a href="javascript:void(0);" @click="changeMenuType('web_url')"><span class="glyphicon glyphicon-link"></span> Link</a></li>
                    <li role="presentation" :class="{'active' : menu.type == 'nested'}" v-if="hasNested"><a href="javascript:void(0);" @click="changeMenuType('nested')"><span class="glyphicon glyphicon-list"></span> Sub Menu</a></li>
                </ul>
                <br>

                <div v-if="menu.type == 'postback'">
                    <div class="text-center">
                        <a href="javascript:void(0);" class="btn btn-primary transparent btn-sm" @click="showAdvanced = !showAdvanced">Show Advanced
                            <i class="fa" :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i>
                        </a>
                    </div>
                    <template v-if="showAdvanced">
                        <div :class="{'has-error': errors.has('buttonValue')}" style="margin-top: 15px;">
                            <input type="text" key="button-value" data-vv-as="Text" :data-vv-name="'buttonValue'" class="form-control" placeholder="Text" style="width: 100%" v-model="menu.payload" v-validate="menu.type == 'postback' ? 'required' : ''">
                            <p class="text-error" v-show="errors.has('buttonValue')">{{ errors.first('buttonValue') }}</p>
                        </div>

                    </template>
                </div>
                <div v-else-if="menu.type == 'web_url'">
                    <div :class="{'has-error': errors.has('buttonLink')}">
                        <input type="url" key="button-link" data-vv-as="Link" :data-vv-name="'buttonLink'" class="form-control" placeholder="Link" style="width: 100%" v-model="menu.url" v-validate="(menu.type == 'web_url' ? 'required|' : '')+'isUrl'">
                        <p class="text-error" v-show="errors.has('buttonLink')">{{ errors.first('buttonLink') }}</p>
                    </div>
                    <br>
                    <div class="btn-group" role="group" >
                        <button type="button" class="btn btn-sm" @click="setWebviewHeightRatio('full')" :class="{'btn-primary' : menu.webview_height_ratio == 'full', 'btn-default' : menu.webview_height_ratio != 'full'}">Full</button>
                        <button type="button" class="btn btn-sm" @click="setWebviewHeightRatio('tall')" :class="{'btn-primary' : menu.webview_height_ratio == 'tall', 'btn-default' : menu.webview_height_ratio != 'tall'}">Tall</button>
                        <button type="button" class="btn btn-sm" @click="setWebviewHeightRatio('compact')" :class="{'btn-primary' : menu.webview_height_ratio == 'compact', 'btn-default' : menu.webview_height_ratio != 'compact'}">Compact</button>
                    </div>
                </div>
                <div v-else-if="menu.type == 'nested'">
                    <p>Create a submenu for this menu item</p>
                </div>


                <div class="text-right" style="margin-top: 10px">
                    <a href="javascript:void(0);" class="btn btn-default" @click="onCancel">Cancel</a>
                    <a href="javascript:void(0);" class="btn btn-primary" @click="savePersistentButton">Save</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props:['value','hasNested','onEdit'],
        data: function(){
            return {
                menu: undefined,
                showAdvanced: false
            }
        },
        mounted: function(){
            var vm = this
            var menu = vm.value
            if (!menu.isShow) {
                menu.isShow = false
            }
            vm.menu = Object.assign({},menu)
            vm.cache_menu = Object.assign({},menu)

            vm.$nextTick(function(){
                if (vm.menu.type == 'postback') {
                    if(vm.menu.type != vm.menu.payload){
                        vm.showAdvanced = true
                    }                
                }
            })
        },
        computed: {
            isEdit: function(){
                return this.onEdit
            }
        },
        methods: {
            savePersistentButton: function(){
                this.$validator.validate().then(result => {
					if (!result) {
                        // do stuff if not valid.
                        vm.goToErrorInput()
						return false
                    }
                    this.menu.isShow = false 
                    this.cache_menu = Object.assign({},this.menu)
                    this.$emit('input',this.menu)
                })
            },
            setWebviewHeightRatio: function(value){
                this.menu.webview_height_ratio = value
                this.$forceUpdate();
            },
            changeMenuType: function(value){
                this.menu.type = value;
                if (value == 'postback') {
                } else if(value == 'web_url') {
                    this.menu.webview_height_ratio = 'full'
                } else if(value == 'nested') {
                    if (!this.menu.call_to_actions) {
                        this.menu.call_to_actions = [
                        ]
                    }
                }
                this.errors.clear();
            },
            onCancel: function(){
                this.menu = Object.assign({},this.cache_menu)
                this.menu.isShow = false
                if (this.menu.title == '') {
                    this.$emit('onDelete')                    
                }
            },
            onChange: function(){
                if(this.menu.type == 'postback'){
                    this.menu.payload = this.menu.title
                }
            }
        },
        watch: {
            value: function(){
                var menu = this.value
                if (!menu.isShow) {
                    menu.isShow = false
                }
                this.menu = Object.assign({},menu)
                this.cache_menu = Object.assign({},menu)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/setting/AddButtonPersistentMenu.vue